/**
 * Quarterly data table module
 */
function irModuleQuarterlyDataTable() {
	if (!document.querySelector('.module.quarterly-data-table')) return;

	const swiperContainers = document.querySelectorAll('.module.quarterly-data-table .swiper-qdt');
	for (const swiperContainer of swiperContainers) {
		new Swiper(swiperContainer, {
			slidesPerView: 1,
			spaceBetween: 0,
			navigation: {
				prevEl: '.swiper-navigation-prev',
				nextEl: '.swiper-navigation-next',
			},
			breakpoints: {
				992: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				},
				1200: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
			},
		});
	}
}
